import { CustomerReviewBackendRequester } from './service/customer-review-backend-requester';
import { CustomerReviewItemComponent } from './customer-review-item.component';
import { HelpfulReviewService } from './service/helpful-review-service';
import { LocalStorageService } from './service/local-storage-service';
import { ReportReviewService } from './service/report-review-service';
import { ReportReviewSheetService } from './service/report-review-sheet-service';
import { ClientComponentLogger } from '../../client-component-logger';
import { CustomerReviewTextExpander } from './service/customer-review-text-expander';

export const CustomerReviewItemFactory = () => {
    const customerReviewBackendRequester = new CustomerReviewBackendRequester(new ClientComponentLogger(CustomerReviewItemComponent.name));
    const localStorageService = new LocalStorageService();
    const helpfulReviewService = new HelpfulReviewService(customerReviewBackendRequester, localStorageService);

    const reportReviewSheetService = new ReportReviewSheetService(customerReviewBackendRequester);
    const reportReviewService = new ReportReviewService(reportReviewSheetService);

    return new CustomerReviewItemComponent(helpfulReviewService, reportReviewService, new CustomerReviewTextExpander());
};
